import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_EditableLabel from "../templates/K_EditableLabel";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface EditableLabelOptions extends ComponentOptions {
    editableInputBind: string | { type: string, value: string };
    required?: boolean | "true" | "false";
    maxLength?: number | string;
    labelId?: string;
    labelClasses?: string;
    labelBind?: string | { type: string, value: string };
    editableLabelClasses?: string;
    editableInputClasses?: string;
    toolTip?: string;
    editableLabelBind?: string;
    hideEditableLabel?: boolean | "true";
    linkClasses?: string;
    zRole?: "NumericTextBox" | "DateTimePicker";
    inputBind?: string;
    inputId?: string;
    inputLabelBind?: string;
    bsc?: string;
    dataFormat?: string;
}

export class EditableLabel extends TemplateComponent {

    options: EditableLabelOptions;

    constructor(options: EditableLabelOptions) {
        super(K_EditableLabel, options);
    }

    preRender() {
        const options = this.options;

        options.labelClasses = options.labelClasses || "";
        options.editableLabelClasses = options.editableLabelClasses || "";
        options.editableInputClasses = options.editableInputClasses || "";
        options.labelBind = buildDataBindSyntax(options.labelBind, "label");
        options.toolTip = ll(options.toolTip);
        options.editableLabelBind = buildDataBindSyntax(options.editableLabelBind, "label");
        options.editableInputBind = buildDataBindSyntax(options.editableInputBind, "input");
    }

    create() {
        if (this.options.hideEditableLabel) {
            $("#" + this.id).find(".editable-input-container").addClass("hide-editable-label");
        }

        if (this.options.toolTip) {
            toolTip({
                selector: $("#" + this.id + " .editable-label")
            });
        }
    }

}
